import * as React from 'react';
import { InputLabel } from './InputLabel';

interface IProps {
    id          : string;
    label       : string;
    checked     : boolean;
    onClick     : any;
    disable?    : boolean;
    name?       : string;
    className?  : string;
    error?      : string;
    useYesNo?   : boolean;
}

export const ToggleSwitch = (props: IProps) => {

    return <div className="toggle-group">
            <input 
                type="checkbox" 
                name="on-off-switch" 
                id="on-off-switch" 
                readOnly
                checked={ props.checked } 
                onClick={ props.onClick } />
            <label htmlFor="on-off-switch">
                { props.label }
            </label>
            <div className="toggle-switch" aria-hidden="true">
                <div className="toggle-switch-label">
                    <div className={`toggle-switch-inner ${ props.useYesNo ? 'yesno' : ''}` } />
                    <div className="toggle-switch-switch" />
                </div>
            </div>
        </div>;

};

export const ToggleInput = (props: IProps) => {

    return <div className={'form-group ' + (props.className)}>
            <InputLabel error={ props.error }>
                { props.label }
            </InputLabel>
            <div className="toggle-group">
                <input 
                    type="checkbox" 
                    name={ props.name }
                    id={ props.name } 
                    readOnly
                    disabled={ props.disable }
                    onClick={ props.onClick }
                    checked={ props.checked } />
                <label htmlFor={ props.name } />
                <div className="toggle-switch" aria-hidden="true">
                    <div className="toggle-switch-label">
                        <div className="toggle-switch-inner" />
                        <div className="toggle-switch-switch" />
                    </div>
                </div>
            </div>
        </div>;

};
